import { SET_SEARCH_RESULTS } from '../action-list'

export const setSearchResults = (query, results) => ({
  type: SET_SEARCH_RESULTS,
  query,
  results,
})
